import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Modal, Form, Card } from "react-bootstrap";
import ModalInputText from "./ModalInputText";
import ModalInputPassword from "./ModalInputPassword";
import { Store } from "react-notifications-component";
import PermissionContext from "./../../../Store/permission-context";
import { AutoComplete, Divider } from "rsuite";
import axios from "axios";
// import PermissionContext from "../../Store/permission-context";

const AdminChangePasswordModal = (props) => {
  const [ShowModal, setShowModal] = useState(props.showmodal);
  const PCtx = useContext(PermissionContext);
  const [AxiosError, setAxiosError] = useState("");

  const [OldGateway, setOldGateway] = useState("");
  const [NewGateway, setNewGateway] = useState("");
  const [ReNewGateway, setReNewGateway] = useState("");
  var CryptoJS = require("crypto-js");

  let errorbackground = {
    backgroundColor: "#f04e00",
    fontFamily: "Times New Roman",
  };
  let successbackground = {
    backgroundColor: "#00ca65",
    fontFamily: "Times New Roman",
  };
  const [errorBackStyle, seterrorBackStyle] = useState(errorbackground);
  const [successBackStyle, setsuccessBackStyle] = useState(successbackground);

  const cancelM = () => {
    setShowModal(false);
    props.cancelModal();
  };

  const changeThePassword = async (e) => {
    e.preventDefault();

    if (NewGateway === ReNewGateway) {
      var TheEncrypted = CryptoJS.AES.encrypt(
        NewGateway,
        "143tonybridget"
      ).toString();

      let newlogindetails = { Username: props.Username, Gateway: TheEncrypted };
      let UpdatePassword = await PCtx.connectAxios(
        "savenewpass.php",
        newlogindetails
      );

      if (!UpdatePassword.includes("Error")) {
        setShowModal(false);
        props.cancelModal();
        PCtx.displayAlert(
          "SUCCESS",
          "Password changed successfully!",
          "success"
        );
      } else {
        PCtx.displayAlert(
          "PASSWORD ERROR",
          "Oops! Error in changing password. Please contact the Administrator or try again later",
          "danger"
        );
      }
    } else {
      PCtx.displayAlert(
        "PASSWORD ERROR",
        "Your two new passwords did not match. Please try again. Note that passwords are case sensitive",
        "danger"
      ); //Passwords did not match
    }
  };

  const thisChange = () => {};

  const saveThePayment = () => {};

  return (
    ShowModal && (
      <Modal
        show={ShowModal}
        onHide={cancelM}
        backdrop="static"
        keyboard={false}
        style={{ fontFamily: "Times New Roman", color: "brown" }}
      >
        <Modal.Header style={successBackStyle} closeButton>
          <Modal.Title
            style={{ color: "brown", fontSize: "17px", fontWeight: "bold" }}
          >
            PASSWORD CHANGE
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            fontFamily: "Times New Roman",
          }}
        >
          <Form onSubmit={changeThePassword}>
            <Row className="justify-content-around">
              <Col md={8} sm={8} xs={8}>
                <ModalInputText
                  Label="Username"
                  Name="Username"
                  Val={props.Username}
                  thischange={setNewGateway}
                  readOnly={true}
                />
              </Col>

              <Col md={8} sm={8} xs={8}>
                <ModalInputPassword
                  Label=" New Password"
                  Name="NewPassword"
                  Val={NewGateway}
                  thischange={setNewGateway}
                  Compulsory={true}
                  required={true}
                />
              </Col>
              <Col md={8} sm={8} xs={8}>
                <ModalInputPassword
                  Label=" Retype New Password"
                  Name="RePassword"
                  Val={ReNewGateway}
                  thischange={setReNewGateway}
                  Compulsory={true}
                  required={true}
                />
              </Col>
              <Button variant="success" type="submit">
                Change Password
              </Button>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    )
  );
};

export default AdminChangePasswordModal;
